// OperationBenefitGroupTable.js
import React, { useState } from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const OperationBenefitGroupTable = ({ data, onEdit, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const headers = ["Category", "Rate", "Actions"];
  const accessors = ["rateCategory", "rate", "actions"];

  const actions = [
    {
      tooltip: "Edit Benefit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    }
  ];

  return (
    <CreateTable
      tableName="BenefitTable"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      isLoading={loading}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={5} // Smaller page size for column view
      totalItems={data?.length || 0}
    />
  );
};

export default OperationBenefitGroupTable;